export class TaskMarkerWithColor {
  constructor(taskMarker, color) {
    this.taskMarker = taskMarker;
    this.color = color;
  }

}